import getConfig from 'next/config';

export const initializeAmazonConnectChat = () => {
  const { publicRuntimeConfig = {} } = getConfig() || {};

  window.amazon_connect =
    window.amazon_connect ||
    function (...props) {
      (window['amazon_connect'].ac = window['amazon_connect'].ac || []).push(props);
    };

  if (window.amazon_connect) {
    window.amazon_connect('styles', {
      iconType: 'CHAT',
      openChat: { color: '#ffffff', backgroundColor: '#521e5a' },
      closeChat: { color: '#ffffff', backgroundColor: '#521e5a' },
    });
    window.amazon_connect('snippetId', publicRuntimeConfig.NEXT_PUBLIC_AMAZON_CHAT_SNIPPET_ID);
    window.amazon_connect('supportedMessagingContentTypes', [
      'text/plain',
      'text/markdown',
      'application/vnd.amazonaws.connect.message.interactive',
      'application/vnd.amazonaws.connect.message.interactive.response',
    ]);

    // JWT authentication for secure access to the chat platform
    window.amazon_connect('authenticate', function (callback: (token: string) => void) {
      window
        .fetch(
          'https://yrvb2evr5l.execute-api.eu-west-2.amazonaws.com/token-generation/wb-chat-jwt-token'
        )
        .then((res) => {
          res.json().then((data) => {
            callback(data.token);
          });
        });
    });

    // Chat window customization
    window.amazon_connect('customizationObject', {
      header: {
        dropdown: true,
        dynamicHeader: false,
      },
      transcript: {
        hideDisplayNames: false,
        eventMessages: {
          participantJoined: '{name} has joined the chat',
          participantDisconnect: '',
          participantLeft: '{name} has ended the chat',
          participantIdle: '{name}, are you still there?',
          participantReturned: '',
          chatEnded: 'Chat ended',
        },
        displayIcons: false,
        iconSources: {
          botMessage: 'imageURL',
          systemMessage: 'imageURL',
          agentMessage: 'imageURL',
          customerMessage: 'imageURL',
        },
      },
      composer: {
        disableEmojiPicker: false,
        disableCustomerAttachments: false,
      },
      footer: {
        disabled: false,
        skipCloseChatButton: false,
      },
    });

    // Callback function to store and clear chat transcript from the cookies
    window.amazon_connect('registerCallback', {
      CONNECTION_ESTABLISHED: () => {
        document.cookie = `activeChat=${sessionStorage.getItem(
          'persistedChatSession'
        )}; SameSite=None; Secure`;
      },
      CHAT_ENDED: () => {
        document.cookie = 'activeChat=; SameSite=None; Secure';
      },
    });

    // To maintain chat persist across multiple windows
    const cookie = document.cookie.split('; ').find((c) => c.startsWith('activeChat='));
    if (cookie) {
      const activeChatValue = cookie.split('=')[1];
      sessionStorage.setItem('persistedChatSession', activeChatValue);
    }
  }
};
